<template>
  <CRow>
    <CCol col="12" lg="12">
      <div class="detail-div">
        <CRow>
          <div>
            <CModal :title="submitType === 'Update' ? $lang.post.crud.edit : $lang.common.general.reason" size="lg"
              :show.sync="largeModal" :no-close-on-backdrop="true" color="primary">
              <CCardBody>
                <CRow>
                  <CCol md="12">
                    <c-textarea v-model="machine.reason" :rows="5" :cols="10" placeholder="Add Reason"></c-textarea>
                  </CCol>
                  <CCol md="6">
                    <div class="form-group">
                      <CButton color="primary" v-c-tooltip="$lang.buttons.general.crud.submit" :disabled="submitted"
                        v-on:click="blockPost(statusId)">
                        Submit
                      </CButton>
                    </div>
                  </CCol>
                </CRow>
              </CCardBody>
              <template #footer style="display: none">
                <CButton @click="darkModal = false" color="danger" style="display: none">Discard</CButton>
                <CButton @click="darkModal = false" color="success" style="display: none">Accept</CButton>
              </template>
            </CModal>
          </div>
        </CRow>
        <CRow>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              {{ $lang.machine.form.user }}
            </p>
            <p class="custome-detail">
              <ProfilerDetail :username="machine.userWithCompany" :profilerId="machine.userId"></ProfilerDetail>
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4" v-show="machine.branchInfo" v-if="machine.whose === 'Company'">
            <p class="custome-labal">{{ $lang.post.form.branch }}</p>
            <BranchComponent :data="machine.branchInfo"></BranchComponent>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">{{ $lang.machine.form.name }}</p>
            <p class="custome-detail">{{ machine.name }}</p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">{{ $lang.machine.form.manufacturer }}</p>
            <p class="custome-detail">{{ machine.manufacturer }}</p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">{{ $lang.machine.form.modelNumber }}</p>
            <p class="custome-detail">{{ machine.modelNumber }}</p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">{{ $lang.machine.form.machineCondition }}</p>
            <p class="custome-detail">{{ machine.machineCondition}}</p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">{{ $lang.machine.form.yearOfManufacture }}</p>
            <p class="custome-detail">{{ machine.yearOfManufacture }}</p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">{{ $lang.machine.form.fuelRequirement }}</p>
            <p class="custome-detail">{{ machine.fuelRequirement }}</p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">{{ $lang.machine.form.fuelType }}</p>
            <p class="custome-detail">{{ machine.fuelType }}</p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">{{ $lang.machine.form.noOfPersonMontoring }}</p>
            <p class="custome-detail">{{ machine.noOfPersonMontoring }}</p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">{{ $lang.machine.form.quantity }}</p>
            <p class="custome-detail">{{ machine.quantity }}</p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">{{ $lang.machine.form.weight }}</p>
            <p class="custome-detail">{{ machine.weight }}</p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">{{ $lang.machine.form.length }}</p>
            <p class="custome-detail">{{ machine.length }}</p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">{{ $lang.machine.form.width }}</p>
            <p class="custome-detail">{{ machine.width }}</p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">{{ $lang.machine.form.height }}</p>
            <p class="custome-detail">{{ machine.height }}</p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">{{ $lang.machine.form.usageHours }}</p>
            <p class="custome-detail">{{ machine.usageHours }}</p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">{{ $lang.machine.form.warrantyStatus }}</p>
            <p class="custome-detail">{{ machine.warrantyStatus }}</p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">{{ $lang.machine.form.transactionType }}</p>
            <p class="custome-detail">{{ machine.transactionType }}</p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">{{ $lang.machine.form.workStartDate }}</p>
            <p class="custome-detail">{{ machine.workStartDate }}</p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">{{ $lang.machine.form.workEndDate }}</p>
            <p class="custome-detail">{{ machine.workEndDate }}</p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">{{ $lang.machine.form.rentalPricePerHour }}</p>
            <p class="custome-detail">{{ machine.rentalPricePerHour }}</p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">{{ $lang.machine.form.rentalDeposit }}</p>
            <p class="custome-detail">{{ machine.rentalDeposit }}</p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">{{ $lang.machine.form.salePrice }}</p>
            <p class="custome-detail">{{ machine.salePrice }}</p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">{{ $lang.machine.form.acquisitionDate }}</p>
            <p class="custome-detail">{{ machine.acquisitionDate }}</p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">{{ $lang.machine.form.minPrice }}</p>
            <p class="custome-detail">{{ machine.minPrice }}</p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">{{ $lang.machine.form.maxPrice }}</p>
            <p class="custome-detail">{{ machine.maxPrice }}</p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">{{ $lang.machine.form.category }}</p>
            <p class="custome-detail">{{ machine.category }}</p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">{{ $lang.machine.form.machineIndustry }}</p>
            <p class="custome-detail">{{ machine.machineIndustry }}</p>
          </CCol>
          <!-- <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">{{ $lang.machine.form.subCategory }}</p>
            <p class="custome-detail">{{ machine.subCategory.title }}</p>
          </CCol> -->
          <CCol sm="12" md="12" lg="12">
            <p class="custome-labal">{{ $lang.machine.form.description }}</p>
            <Description :title="$lang.machine.form.description" :content="machine.description" :length="90" />
          </CCol>
        </CRow>
        <EntityTimeStamp :createdAt="machine.createdAt" :updatedAt="machine.updatedAt"></EntityTimeStamp>
        <CRow v-show="machine.blockedReason">
          <CCol sm="12" align="left">
            <strong>Blocked Reason: </strong> {{ machine.blockedReason }}
          </CCol>
        </CRow>
        <CRow v-if="!machine.blockedReason && machine.isStatus != 'Closed'">
            <CCol sm="12" align="left">
              <CButton :color="statusColor" v-c-tooltip="statusLabel" v-on:click="beforeBlocked()">
                {{ statusLabel }}
              </CButton>
            </CCol>
        </CRow>
      </div>
    </CCol>
  </CRow>
</template>
<script>
import Vue from "vue";
import VueForm from "vue-form";
import store from "/src/store/store.js";
import BranchComponent from "/src/views/branch/Component";
import {
  machine,
  industry,
  duration,
  currencytype,
  users,
  skills,
} from "/src/store/url.js";
import { Mixin } from "/src/mixins/index.js";
import options from "/src/validations/validations.js";
import VueNotifications from "vue-notifications";
import VueToasted from "vue-toasted";
import moment from "moment";
import Description from "/src/views/Description";
import ProfilerDetail from "/src/views/ProfilerDetail.vue";
import { serverBus } from "/src/main";
import EntityTimeStamp from "/src/components/EntityTimeStamp";

function toast({ title, message, type, timeout, cb }) {
  if (type === VueNotifications.types.warn) type = "show";
  return Vue.toasted[type](message, {
    duration: timeout,
    position: "top-left",
  });
}

Vue.use(VueToasted);
const optionss = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast,
  position: "top-center",
};
Vue.use(VueNotifications, optionss);
Vue.use(VueForm, options);

export default {
  name: "MachineEdit",
  mixins: [Mixin],
  components: {
    Description,
    ProfilerDetail,
    EntityTimeStamp,
    BranchComponent
  },
  data() {
    return {
      submitType: "",
      userId: "",
      largeModal: false,
      statusId: "",
      statusLabel: "Block",
      statusColor: "danger",
      submitted: false,
      showTax: true,
      err_msg: "",
      dismissCountDown: 0,
      postTypeList: [],
      statusOption: [],
      industryOptions: [],
      subIndustryOptions: [],
      resourceTypeOptions: [],
      currencyOptions: [],
      durationOptions: [],
      remoteWorkOptions: [],
      userOptions: [],
      skillsOptions: [],
      selectedSkills: [],
      getSkills: [],
      self: this,
      module: machine,
      moduleIndustry: industry,
      moduleDuration: duration,
      moduleCurrency: currencytype,
      moduleSkills: skills,
      moduleUser: users,
      machine: {
        machineCondition : "",
        fuelType : "",
        transactionType : "",
        machineIndustry : "",
        category : "",
        reason:"",
        isActive : "",
      },
    };
  },

  mounted() {
    store.commit("showLoader", true);
    const type = {
      YES: "Yes",
      NO: "No",
    };
    let self = this;
    self.statusOption.push(
      { value: "1", label: "Active" },
      { value: "0", label: "InActive" },
      { value: "2", label: "Block" },
      { value: "3", label: "Closed" },
      { value: "4", label: "Draft" }
    );
    self.dismissCountDown = 0;
    const id = this.$route.params.id;

    self.remoteWorkOptions.push(
      { value: type.YES, label: type.YES },
      { value: type.NO, label: type.NO }
    );
    self.dismissCountDown = 0;
    self.editId = id;
    axios
      .get(this.viewUrlApi(this.module, id))
      .then((response) => {
        if (response.data) {
          const responseData = response.data.data;
          self.machine = responseData;
          self.machine.machineCondition = responseData.machineCondition.title ?? "",
          self.machine.fuelType = responseData.fuelType.title ?? "",
          self.machine.transactionType = responseData.transactionType.title ?? "",
          self.machine.machineIndustry = responseData.machineIndustry.title ?? "",
          self.machine.category = responseData.category.title ?? "",
          self.machine.isActive = responseData.status,
          // self.machine.date = responseData.startDate; //  moment(responseData.startDate, 'YYYY-MM-DD').format('DD/MM/YYYY');
          // self.machine.name = (responseData.name !== "") ? responseData.name : '-';
          // self.machine.ratingLabel = responseData.ratingLabel;
          // self.machine.description = (responseData.description !== "") ? responseData.description : '-';
          // self.machine.budget = responseData.budget ?? '-';
          // self.machine.isActive = responseData.isActive;
          // self.machine.isStatus = responseData.isActiveStatus;
          // self.machine.visibility = responseData.visibility;
          // self.machine.showToOther = responseData.showToOther;
          // self.machine.branchInfo = responseData.branchInfo;
          // self.machine.blockedReason = responseData.blockedReason;

          // if (self.machine.isStatus === "Active") {
          //   self.machine.isStatus = 'Open';
          //   // console.log(this.getStatusLabel(2));
          //   self.statusLabel = this.getStatusLabel(2);
          //   self.statusId = "2";
          //   self.statusColor = "danger";
          // } else {
          //   self.statusId = "1";
          //   self.statusLabel = this.getStatusLabel(1);
          //   self.statusColor = "success";
          // }

          // self.machine.remoteWork = responseData.remoteWork;
          // self.machine.max_budget = responseData.maxBudget;
          // self.machine.min_budget = responseData.minBudget;
          // self.machine.machineType = responseData.machineType;
          // self.machine.remoteWorkAddress = responseData.remoteWorkAddress;
          // self.machine.isGST = responseData.isGST ?? '-';
          // self.machine.tax = responseData.GstTax;
          // if (responseData.isGST === "No") {
          //   self.showTax = false;
          // }
          // self.machine.status = {
          //   value: responseData.isActive,
          //   label: responseData.isActiveStatus,
          // };

          // self.machine.industry = responseData.industry ? {
          //   value: responseData.industry.id,
          //   label: responseData.industry.title,
          // } : '';

          // const servicesList = [];
          // responseData.subindustry.map(function (value, key) {
          //   servicesList.push(value.title);
          // });
          // self.machine.subIndustry = servicesList.join(", ");

          // self.machine.duration = responseData.duration ? responseData.duration.value : '-';
          // self.machine.currency = responseData.currency ?? '';
          // self.machine.symbol = responseData.currency ? responseData.currency.symbol : '';

          // self.machine.whose = responseData.user.whose;
          // if (responseData.user.company)
          //   self.machine.user = responseData.user.company;
          // else if (responseData.user.name)
          //   self.machine.user = responseData.user.name;

          // self.machine.userWithCompany = responseData.user.userWithCompany;
          // self.machine.userId = responseData.userId;
          self.machine.createdAt = responseData.createdAt;
          self.machine.updatedAt = responseData.updatedAt;

          // const list = [];
          // responseData.skills.map(function (value, key) {
          //   list.push(value.title);
          // });
          // self.machine.skills = list.join(", ");

          store.commit("showLoader", false); // Loader Off
        }
      })
      .catch(function (error) {
        store.commit("showLoader", false); // Loader Off
      });
  },
  methods: {
    showProfile(userId) {
      serverBus.$emit("profilerId", userId);
    },

    getHumanDate: function (date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },

    getStatusLabel(getStatus) {
      let valObj = " ";
      valObj = this.statusOption.filter(function (elem) {
        if (elem.value == getStatus) return elem.value;
      });
      if (valObj.length > 0) return valObj[0].label;
    },

    beforeBlocked() {
      let self = this;
      self.machine.reason = "";
      // console.log(self.machine);
      if (self.machine.isActive === 1) {
        this.largeModal = true;
      } else {
        this.blockPost(self.statusId);
      }
    },

    blockPost(statusId) {
      let self = this;
      self.submitted = true; //Enable Button
      if (self.machine.isActive === 1) {
        if (self.machine.reason === "") {
          self.submitted = false; //Enable Button
          return false;
        }
        this.$swal({
          title: this.$lang.common.status.want_to_block,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#e55353",
          confirmButtonText: this.$lang.common.status.yes_block,
          cancelButtonText: this.$lang.common.status.cancel,
        }).then((result) => {
          if (result.value) {
            const id = this.$route.params.id;

            setTimeout(() => {
              let self = this;
              const postData = {
                status: statusId,
                reason: self.machine.reason,
              };
              let status, button;
              if (self.statusId === "1") {
                self.statusId = "2";
                self.statusColor = "danger";
                status = this.getStatusLabel(1);
                button = "Block";
              } else {
                self.statusId = "1";
                self.statusColor = "success";
                status = "Blocked";
                button = this.getStatusLabel(1);
              }

              axios
                .post(this.statusUrlWeb(this.module, id), postData)
                .then(function (response) {
                  if (response.data.code === 200) {
                    self.machine.isStatus = status;
                    self.statusLabel = button;
                    self.largeModal = false;
                    self.submitted = false; //Enable Button
                    self.$router.go();
                  } else {
                    self.err_msg = response.data.message;
                    self.dismissCountDown = 10;
                  }
                })
                .catch(function (error) {
                  self.submitted = false; //Enable Button
                });
            }, 500);
          }
        });
      } else {
        const id = this.$route.params.id;
        let self = this;
        const postData = {
          status: statusId,
          reason: "",
        };
        let status, button;
        if (self.statusId === "1") {
          self.statusId = "2";
          self.statusColor = "danger";
          status = this.getStatusLabel(1);
          button = "Block";
        } else {
          self.statusId = "1";
          self.statusColor = "success";
          status = "Blocked";
          button = this.getStatusLabel(1);
        }
        axios
          .post(this.statusUrlWeb(this.module, id), postData)
          .then(function (response) {
            if (response.data.code === 200) {
              self.machine.isStatus = status;
              self.statusLabel = button;
              self.largeModal = false;
              self.submitted = false; //Enable Button
              self.$router.go();
            } else {
              self.err_msg = response.data.message;
              self.dismissCountDown = 10;
            }
          })
          .catch(function (error) {
            self.submitted = false; //Enable Button
          });
      }
    },
  },
};
</script>
<style>
div .error {
  color: red;
}

.hasError label {
  color: red;
}
</style>
